export const resources = {
  en: {
    translation: {
      common: {
        portalTitle: "{{shopName}} - Returns and Exchanges Portal",
        portalDescription:
          "Hassle-free returns for your orders, brought to you by Pragma",
        loading: "Loading",
        language: "Language",
        actions: {
          proceed: "Proceed",
          change: "Change",
          save: "Save",
          saveAddress: "Save Address",
          saveAndContinue: "Save & Continue",
          continue: "Continue",
          search: "Search",
          check: "Check",
          submit: "Submit",
          close: "Close",
          resendOtp: "Resend OTP"
        }
      },
      footer: {
        needHelp: "Need Help?",
        poweredBy: "Powered by"
      },
      login: {
        termsTitle: "Terms and Conditions:",
        termsClose: "Close",
        otpIntro: "We have sent an OTP to",
        enterOtp: "Enter OTP here",
        otpResent: "OTP Resent Successfully",
        otpRetry: "Hmmm .... Can you please try again ?",
        otpGenericError: "Something went wrong. Please try again in sometime",
        otpResendError: "An error occurred",
        byProceeding: "By proceeding, you accept our",
        termsLink: "Terms & Conditions",
        field: {
          phone: {
            label: "Phone",
            placeholder: "9876543210",
            helperText:
              "Enter the phone number used for placing the order",
            patternErrorText:
              "Invalid phone number. Please enter a valid phone number.",
            requiredErrorText: "Phone is required"
          },
          email: {
            label: "Email",
            placeholder: "johndoe@gmail.com",
            helperText:
              "Enter the email used for placing the order",
            patternErrorText:
              "Invalid email address. Please check entered information.",
            requiredErrorText: "Email is required"
          },
          combinedLight: {
            label: "Email or Phone",
            placeholder: "johndoe@gmail.com / 9876543210",
            helperText:
              "Enter email address or phone number used for placing the order",
            patternErrorText:
              "Invalid email address or phone number. Please check entered information.",
            requiredErrorText: "Email address / phone number is required"
          },
          combinedDark: {
            label: "Email / Phone",
            placeholder: "johndoe@gmail.com / 9876543210",
            helperText: "Enter Email/Phone used for placing the order",
            patternErrorText:
              "Invalid email/phone. Please check entered information.",
            requiredErrorText: "Email / Phone is required"
          }
        }
      },
      orders: {
        notEligible: "Order is not eligible for refund / exchange",
        notFound: "No order found. Please check the Order Id again.",
        searchOrderId: "Order ID.",
        noSearchResults: "Sorry we couldn't find any order with that name",
        noEligibleOrders: "Oops! No eligible orders found.",
        changePhoneEmail: "Change Phone/Email ?",
        or: "Or"
      },
      address: {
        pickupAndDeliveryAddress: "Pickup & Delivery Address",
        deliveryAddress: "Delivery Address",
        notServiceable: "Your pincode is not serviceable.",
        shipBackTo: "Ship your products back to",
        invalidFields:
          "Please fill all the fields without any special characters (*, /, & , - , _)",
        invalidFieldsShort:
          "Please fill all the fields without special characters",
        addressTooShort: "Address is too short. Please add a valid address",
        addressTooLong: "Address is too long. Please add a shorter address",
        noSpecialCharactersAllowed:
          "No special characters allowed in address details",
        fillAllFields: "Please fill all the fields",
        labels: {
          pinCode: "PIN Code",
          state: "State",
          city: "City",
          firstName: "First Name",
          lastName: "Last Name",
          email: "Email",
          phoneNumber: "Phone Number",
          addressLine1: "Address Line 1",
          addressLine2: "Address Line 2"
        },
        replaceOrExchangeRequest: "{{requestType}} request"
      },
      success: {
        your: "Your",
        replacement: "Replacement",
        return: "Return",
        exchange: "Exchange",
        returnAndExchange: "Return and Exchange",
        requestPlacedSuccessfully: "Request Placed Successfully",
        trackRequest: "Track your return request. Request ID"
      },
      tracking: {
        requestRejected: "Request Rejected",
        requestCreated: "Request Created",
        processingRequest: "Processing Request",
        pickupCompleted: "Pickup Completed",
        refundInitiated: "Refund Initiated",
        refundCompleted: "Refund Completed",
        exchangeInitiated: "Exchange Initiated",
        exchangeCompleted: "Exchange Completed",
        requestCompleted: "Request Completed"
      }
    }
  },
  hi: {
    translation: {
      common: {
        portalTitle: "{{shopName}} - रिटर्न और एक्सचेंज पोर्टल",
        portalDescription:
          "आपके ऑर्डर के लिए आसान रिटर्न, प्रग्मा द्वारा संचालित",
        loading: "लोड हो रहा है",
        language: "भाषा",
        actions: {
          proceed: "आगे बढ़ें",
          change: "बदलें",
          save: "सहेजें",
          saveAddress: "पता सहेजें",
          saveAndContinue: "सहेजें और आगे बढ़ें",
          continue: "जारी रखें",
          search: "खोजें",
          check: "जांचें",
          submit: "सबमिट करें",
          close: "बंद करें",
          resendOtp: "ओटीपी फिर भेजें"
        }
      },
      footer: {
        needHelp: "मदद चाहिए?",
        poweredBy: "द्वारा संचालित"
      },
      login: {
        termsTitle: "नियम और शर्तें:",
        termsClose: "बंद करें",
        otpIntro: "हमने एक ओटीपी भेजा है",
        enterOtp: "यहां ओटीपी दर्ज करें",
        otpResent: "ओटीपी सफलतापूर्वक फिर भेजा गया",
        otpRetry: "हम्म... कृपया फिर से प्रयास करें?",
        otpGenericError: "कुछ गलत हो गया। कृपया थोड़ी देर बाद फिर कोशिश करें",
        otpResendError: "एक त्रुटि हुई",
        byProceeding: "आगे बढ़कर, आप हमारी",
        termsLink: "नियम और शर्तें",
        field: {
          phone: {
            label: "फोन",
            placeholder: "9876543210",
            helperText:
              "वह फोन नंबर दर्ज करें जिसका उपयोग आपने ऑर्डर देने के लिए किया था",
            patternErrorText:
              "अमान्य फोन नंबर। कृपया सही फोन नंबर दर्ज करें।",
            requiredErrorText: "फोन आवश्यक है"
          },
          email: {
            label: "ईमेल",
            placeholder: "johndoe@gmail.com",
            helperText:
              "वह ईमेल दर्ज करें जिसका उपयोग आपने ऑर्डर देने के लिए किया था",
            patternErrorText:
              "अमान्य ईमेल पता। कृपया दर्ज की गई जानकारी जांचें।",
            requiredErrorText: "ईमेल आवश्यक है"
          },
          combinedLight: {
            label: "ईमेल या फोन",
            placeholder: "johndoe@gmail.com / 9876543210",
            helperText:
              "वह ईमेल पता या फोन नंबर दर्ज करें जिसका उपयोग आपने ऑर्डर देने के लिए किया था",
            patternErrorText:
              "अमान्य ईमेल पता या फोन नंबर। कृपया दर्ज की गई जानकारी जांचें।",
            requiredErrorText: "ईमेल पता / फोन नंबर आवश्यक है"
          },
          combinedDark: {
            label: "ईमेल / फोन",
            placeholder: "johndoe@gmail.com / 9876543210",
            helperText:
              "वह ईमेल/फोन दर्ज करें जिसका उपयोग आपने ऑर्डर देने के लिए किया था",
            patternErrorText:
              "अमान्य ईमेल/फोन। कृपया दर्ज की गई जानकारी जांचें।",
            requiredErrorText: "ईमेल / फोन आवश्यक है"
          }
        }
      },
      orders: {
        notEligible: "यह ऑर्डर रिफंड / एक्सचेंज के लिए पात्र नहीं है",
        notFound: "कोई ऑर्डर नहीं मिला। कृपया ऑर्डर आईडी फिर जांचें।",
        searchOrderId: "ऑर्डर आईडी",
        noSearchResults: "उस नाम से हमें कोई ऑर्डर नहीं मिला",
        noEligibleOrders: "उफ़! कोई पात्र ऑर्डर नहीं मिला।",
        changePhoneEmail: "फोन/ईमेल बदलें?",
        or: "या"
      },
      address: {
        pickupAndDeliveryAddress: "पिकअप और डिलीवरी पता",
        deliveryAddress: "डिलीवरी पता",
        notServiceable: "आपका पिनकोड सेवाक्षेत्र में नहीं है।",
        shipBackTo: "अपने उत्पाद यहां वापस भेजें",
        invalidFields:
          "कृपया सभी फ़ील्ड बिना किसी विशेष अक्षर (*, /, & , - , _) के भरें",
        invalidFieldsShort:
          "कृपया सभी फ़ील्ड विशेष अक्षरों के बिना भरें",
        addressTooShort: "पता बहुत छोटा है। कृपया सही पता जोड़ें",
        addressTooLong: "पता बहुत लंबा है। कृपया छोटा पता जोड़ें",
        noSpecialCharactersAllowed:
          "पता विवरण में विशेष अक्षर अनुमत नहीं हैं",
        fillAllFields: "कृपया सभी फ़ील्ड भरें",
        labels: {
          pinCode: "पिन कोड",
          state: "राज्य",
          city: "शहर",
          firstName: "पहला नाम",
          lastName: "अंतिम नाम",
          email: "ईमेल",
          phoneNumber: "फोन नंबर",
          addressLine1: "पता पंक्ति 1",
          addressLine2: "पता पंक्ति 2"
        },
        replaceOrExchangeRequest: "{{requestType}} अनुरोध"
      },
      success: {
        your: "आपका",
        replacement: "रिप्लेसमेंट",
        return: "रिटर्न",
        exchange: "एक्सचेंज",
        returnAndExchange: "रिटर्न और एक्सचेंज",
        requestPlacedSuccessfully: "अनुरोध सफलतापूर्वक दर्ज किया गया",
        trackRequest: "अपने रिटर्न अनुरोध को ट्रैक करें। अनुरोध आईडी"
      },
      tracking: {
        requestRejected: "अनुरोध अस्वीकृत",
        requestCreated: "अनुरोध बनाया गया",
        processingRequest: "अनुरोध संसाधित हो रहा है",
        pickupCompleted: "पिकअप पूर्ण",
        refundInitiated: "रिफंड शुरू",
        refundCompleted: "रिफंड पूरा",
        exchangeInitiated: "एक्सचेंज शुरू",
        exchangeCompleted: "एक्सचेंज पूरा",
        requestCompleted: "अनुरोध पूर्ण"
      }
    }
  }
};
